<div class="sidebarFullContent">
  <!-- Sidebar Header starts -->
  <div class="sidebar-header">
    <!-- <div class="sidebar-header"> -->
    <div class="logo clearfix">
      <img style="width: 44px" src="../../../../assets/img/logos/skillflo-logo.png" />
      <img *ngIf="!isTitleCollapse" style="width: 105px" src="../../../../assets/img/logos/skillflo-title.png"
        alt="Skillflo" />
    </div>
    <button class="toggle-btn" (click)="toggleSidebar()">
      <img style="width: 19px" src="../../../../assets/img/sidebar_img/menu.svg" alt="Sidebar Icon" />
    </button>
    <!-- </div> -->
  </div>
  <!-- Sidebar Header Ends -->

  <!-- Sidebar Content starts -->
  <ng-scrollbar [style]="{
      '--scrollbar-border-radius': '10px'
    }" class="sidebar-content" [ngClass]="{ collapsed: isCollapsed }">
    <div class="nav-container">
      <ul class="navigation" appSidebarList>
        <!-- First level menu -->
        <li appSidebarlink [level]="firstDepth" [attr.pageid]="menuItem.pageid" (click)="
            menuItem.submenu.length > 0 && isCollapsed
              ? toggleSidebarIN()
              : null
          " [routePath]="menuItem.path" [classes]="menuItem.class" [title]="menuItem.title" [parent]=""
          *ngFor="let menuItem of menuItems" [ngClass]="{
            'has-sub': menuItem.class === 'has-sub' ? true : false,
            open:
              activeTitles.includes(menuItem.title) && !nav_collapsed_open
                ? true
                : false,
            'nav-collapsed-open':
              nav_collapsed_open && activeTitles.includes(menuItem.title)
          }" [routerLinkActive]="
            activeTitles.includes(menuItem.title) ? '' : 'active'
          " [routerLinkActiveOptions]="{ exact: true }">
          <a appSidebarAnchorToggle [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
            *ngIf="!menuItem.isExternalLink; else externalLinkBlock">
            <i class="sbarIcons" [ngClass]="[menuItem.icon]"></i>
            <span class="menu-title" [innerHTML]="menuItem.title | translate"></span>
            <span *ngIf="menuItem.badge != ''" [ngClass]="[menuItem.badgeClass]">{{ menuItem.badge }}</span>
          </a>

          <ng-template #externalLinkBlock>
            <a [href]="[menuItem.path]" target="_blank">
              <i class="sbarIcons" [ngClass]="[menuItem.icon]"></i>
              <span class="menu-title" [innerHTML]="menuItem.title | translate"></span>
              <span *ngIf="menuItem.badge != ''" [ngClass]="[menuItem.badgeClass]">{{ menuItem.badge }}</span>
            </a>
          </ng-template>
          <!-- Second level menu -->
          <ul class="menu-content" *ngIf="menuItem.submenu.length > 0"
            [@slideInOut]="activeTitles.includes(menuItem.title) ? true : false">
            <li appSidebarlink [level]="secondDepth" [attr.pageid]="menuItem.pageid" [routePath]="menuSubItem.path"
              [classes]="menuSubItem.class" [title]="menuSubItem.title" [parent]="menuItem.title"
              *ngFor="let menuSubItem of menuItem.submenu" [routerLinkActive]="
                menuSubItem.submenu.length > 0 ? '' : 'active'
              " [ngClass]="{
                'has-sub': menuSubItem.class === 'has-sub' ? true : false,
                open:
                  activeTitles.includes(menuSubItem.title) &&
                  !nav_collapsed_open
                    ? true
                    : false,
                'nav-collapsed-open':
                  nav_collapsed_open && activeTitles.includes(menuSubItem.title)
              }">
              <a appSidebarAnchorToggle [routerLink]="
                  menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]
                " *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock">
                <i class="sbarIcons" [ngClass]="[menuSubItem.icon]"></i>
                <span class="menu-title" [innerHTML]="menuSubItem.title | translate"></span>
                <span *ngIf="menuSubItem.badge != ''" [ngClass]="[menuSubItem.badgeClass]">{{ menuSubItem.badge
                  }}</span>
              </a>
              <ng-template #externalSubLinkBlock>
                <a [routerLink]="[menuSubItem.path]">
                  <i class="sbarIcons" [ngClass]="[menuSubItem.icon]"></i>
                  <span class="menu-title" [innerHTML]="menuSubItem.title | translate"></span>
                  <span *ngIf="menuSubItem.badge != ''" [ngClass]="[menuSubItem.badgeClass]">{{ menuSubItem.badge
                    }}</span>
                </a>
              </ng-template>
            </li>
          </ul>
        </li>
      </ul>
      <!-- <div class="nav-item">
      

          <a
            class="header-icon logout-icon"
            (click)="logOut()"
            href="javascript:;"
            ngbTooltip="Logout"
            placement="bottom"
          >
          </a>
          <div class="nav-item">
            <a
              class="header-icon user-icon"
              [routerLink]="['/profile']"
              ngbTooltip="Profile"
              placement="bottom"
            >
            </a>
          </div>
      </div> -->
    </div>

    <!-- Other sidebar content here -->

    <!-- <div class="profile-section bottom-0">
        <a
          class="header-icon user-icon"
          [routerLink]="['/profile']"
          ngbTooltip="Profile"
          placement="bottom"
        >
          <img alt="Profile Icon" class="profile-icon">
        </a>
    
        <h4 class="profile-name">
          Dinesh K
        </h4>
    
        <a
          class="header-icon logout-icon"
          (click)="logOut()"
          href="javascript:;"
          ngbTooltip="Logout"
          placement="bottom"
        >
          <img alt="Logout Icon" class="logout-icon">
        </a>
      </div> -->
  </ng-scrollbar>
  <!-- Sidebar Content Ends -->
</div>